import React from 'react';
import styled from 'styled-components';

import type { IPopularDestinationsOfferRegionWithPrice } from 'src/routes/Home/store/popularDestinationsOffers/types';

import { RegionLabel } from './RegionLabel';

interface ICardLabels {
  regions: IPopularDestinationsOfferRegionWithPrice[];
}

export const CardLabels = (props: ICardLabels) => {
  const { regions } = props;

  return (
    <CardLabelsContainer>
      {regions.map((regionProps) => (
        <RegionLabel
          {...regionProps}
          key={`relinking_new_year_card_region_${regionProps.place}`}
        />
      ))}
    </CardLabelsContainer>
  );
};

const CardLabelsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  max-height: 100%;
  overflow: hidden;
`;
